"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomToolTip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var styles_1 = require("@material-ui/core/styles");
var Components_1 = require("../../Components");
var theme_1 = require("../../theme");
var classificationOverrideInfo = function (overrideDate) { return (react_1.default.createElement("div", null,
    react_1.default.createElement("div", null, "Override set on: " + overrideDate),
    react_1.default.createElement("br", null),
    react_1.default.createElement("div", null, "Primary classifications are normally calculated automatically for each month from the classification weights and the Classification System configuration"),
    react_1.default.createElement("div", null,
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", null, "You can override this automatic calculation by adding one or more override here"),
            react_1.default.createElement("li", null, "Overrides entered for a month apply to sub-sequent months until changed. The first override implicitly applies to all earlier months as well"),
            react_1.default.createElement("li", null, "Note that if any overrides are entered they completely replace the automatic calculation for all months"))))); };
exports.CustomToolTip = function (_a) {
    var _b;
    var selectedAsOfDate = _a.selectedAsOfDate;
    var useStyles = styles_1.makeStyles({
        customTooltip: {
            borderRadius: '0px',
            fontSize: '1.2rem',
            fontFamily: theme_1.theme.fonts.robotoRegular,
            lineHeight: '1.5rem',
            maxWidth: '280px',
            backgroundColor: theme_1.theme.colors.NTDarkGrey[700],
            margin: '4px 12px 4px 12px',
        },
    });
    var classes = useStyles();
    return (react_1.default.createElement(StyledToolTip, { infoText: classificationOverrideInfo((_b = selectedAsOfDate === null || selectedAsOfDate === void 0 ? void 0 : selectedAsOfDate.override) === null || _b === void 0 ? void 0 : _b.date), icon: "status_info_square", classes: {
            tooltip: classes.customTooltip,
        } }));
};
var StyledToolTip = styled_components_1.default(Components_1.ToolTip)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1;
